import { date } from 'quasar'
import ThreePLLotNumberAddEditModel from '../threepllotnumberaddeditmodel-dialog-screen.vue';


export default {
    data: function () {
        return {
            title: '3PL Lot Numbers',
            loading: false,
            channelSettings: {
                ApplicationId: 0
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'LotNumber',
                    label: 'Lot Number',
                    align: 'left',
                    field: row => row.LotNumber,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'PartnerCode',
                    label: 'Partner Code',
                    align: 'left',
                    field: row => row.PartnerCode,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'ClientId',
                    label: 'Client Id',
                    align: 'left',
                    field: row => row.ClientId,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'SKU',
                    label: 'SKU',
                    align: 'left',
                    field: row => row.SKU,
                    sortable: true,
                    style: '',
                },
                {
                    name: 'LastModifiedOn',
                    label: 'Last Modified On',
                    align: 'left',
                    field: row => row.LastModifiedOn,
                    sortable: false,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY hh:mm:ss A'),
                },
                {
                    name: 'LastModifiedBy',
                    label: 'Last Modified By',
                    align: 'left',
                    field: row => row.LastModifiedBy,
                    sortable: false,
                    style: '',
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                }
            ],
            columnsVisible: ['LotNumber', 'PartnerCode', 'ClientId', 'SKU', 'LastModifiedOn', 'LastModifiedBy', 'Actions'],
            dataSource: [],
            editRowKey: null,
            filter: null,
            pagination: {
                sortBy: 'LotNumber',
                descending: false,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            }
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
            });
        },

        refreshScreen() {
            this.title = '3PL Lot Numbers';
            if (this.channelSettings.ApplicationId > 0) {
                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.dataSource = [];
            }
        },

        onCreateActionClick() {
            this.$q.dialog({
                component: ThreePLLotNumberAddEditModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                component: ThreePLLotNumberAddEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                    this.dataSource.splice(currentItemIndex, 1);
                    this.pagination.rowsNumber = this.pagination.rowsNumber - 1;
                }
            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/three_pl_lot_numbers/byApplication/' + this.channelSettings.ApplicationId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                
                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/three_pl_lot_numbers/{id}', id, params);
                let response = await this.$http.delete(url);
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        }
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}